module.exports = __webpack_public_path__ + "static/media/ISAFIS.670ae050.png";